/**
 * This file contains constants used throughout the application
 */

export const DEV = 'dev'
export const TEST = 'test'
export const STAGE = 'stage'

export const ZEUS_TOKEN = 'zeus-token'
export const ZEUS_USER_INFO = 'zeus-user-info'

export const ADMIN = 'admin'
export const LOCAL_DELETE_OK = 'LOCAL_DELETE_OK'
export const LOCAL_DELETE_FAILED = 'LOCAL_DELETE_FAILED'

export const UNEXPECTED_STATE = 'UNEXPECTED_STATE'

export const OK = 'OK'
export const PUT = 'PUT'
export const TOGGLE_HISTORY_EMIT = 'toggleHistory'
export const POST = 'POST'
export const GET = 'GET'
export const BEARER = 'Bearer'
export const DELETE = 'DELETE'

// Start general api status codes
export const FETCH_OK = 'FETCH_OK'
export const FETCH_ERROR = 'FETCH_ERROR'
export const FETCH_ERROR_TIMEOUT = 'FETCH_ERROR_TIMEOUT'

export const POST_OK = 'POST_OK'
export const NOTHING_TO_POST = 'NOTHING_TO_POST'
export const NOT_POSTED = 'NOT_POSTED'
export const POST_ERROR = 'POST_ERROR'
export const PARTIAL_POST_ERROR = 'PARTIAL_POST_ERROR'

export const DELETE_OK = 'DELETE_OK'
export const DELETE_FAILED = 'DELETE_FAILED'
export const NOTHING_TO_DEL = 'NOTHING_TO_DEL'

export const PUT_OK = 'PUT_OK'
export const NOTHING_TO_PUT = 'NOTHING_TO_PUT'
export const NOT_PUT = 'NOT_PUT'
export const PUT_ERROR = 'PUT_ERROR'
export const PARTIAL_PUT_ERROR = 'PARTIAL_PUT_ERROR'

export const FAILED_REVERT = 'FAILED_REVERT'
export const REVERT_OK = 'REVERT_OK'
// End general api status codes

export const NO_MSG = 'NO_MSG'

// START GENERAL INFO MESSAGES
export enum GeneralInfoCode {
  INVALID_FIELD = 'generalTable.invalidField',
  SAVE_ERROR = 'generalTable.saveError',
  SAVE_OK = 'generalTable.saveOk',
  FETCH_ERROR = 'generalTable.fetchError',
  RESET_OK = 'generalTable.resetOk',
}
// END GENERAL INFO MESSAGES

// START TABLE SPECIFIC INFO MESSAGES

export enum GenresInfoCode {
  MEDIA_FETCH_ERROR = 'genres.mediaFetchError',
  PRODUCT_MODULE_FETCH_ERROR = 'genres.productModuleFetchError',
  GENRES_FETCH_ERROR = 'generalTable.fetchError',
  PRODUCTS_FETCH_ERROR = 'genres.productsFetchError',
  GENRE_SAVE_OK = 'generalTable.saveOk',
  GENRE_SAVE_ERROR = 'generalTable.saveError',
  EXTRACT_PRODUCT_MODULES_ERROR = 'genres.extractProductModulesError',
}

export enum DeletedTopicsEventsInfoCode {
  DELETED_TOPICS_EVENTS_POS_FETCH_ERROR = 'generalTable.fetchError',
  DELETED_TOPICS_EVENTS_STAFFER_FETCH_ERROR = 'deletedTopicsEvents.stafferFetchError',
  DELETED_TOPICS_EVENTS_POS_FETCH_ERROR_TIMEOUT = 'deletedTopicsEvents.timeout',
}

export enum SectionInfoCode {
  SECTION_DUPLICATE_ID = 'SECTION_DUPLICATE_ID',
  MISSING_LONG_NAME_DE = 'MISSING_LONG_NAME_DE',
}

export enum StafferRightsFlyByInfoCode {
  SETTINGS_WERE_RESET = 'SETTINGS_WERE_RESET',
  SETTINGS_WERE_SAVED = 'SETTINGS_WERE_SAVED',

}

export enum StafferRightsInfoCode {
  LOSE_OWN_ADMIN_RIGHTS_MSG = 'LOSE_OWN_ADMIN_RIGHTS_MSG',
  UNSAVED_CHANGES_MSG = 'UNSAVED_CHANGES_MSG',
  ADMIN_RIGHTS_REACTIVATED = 'stafferRights.adminReactivated',
}

export enum StafferRightsErrorCode {
  STAFFER_LIST_COULD_NOT_BE_FETCHED = 'STAFFER_LIST_COULD_NOT_BE_FETCHED',
  NO_USER_ID_ERROR = 'NO_USER_ID_ERROR',
  HISTORY_FETCH_FAILED = 'HISTORY_FETCH_FAILED',
  MISSING_SEARCH_STRING = 'MISSING_SEARCH_STRING',
  STAFFER_DATA_COULD_NOT_BE_FETCHED = 'STAFFER_DATA_COULD_NOT_BE_FETCHED',
  ROLE_LIST_FETCH_FAILED = 'ROLE_LIST_FETCH_FAILED',
  SAVE_FAILED = 'SAVE_FAILED',
}

// END TABLE SPECIFIC INFO MESSAGES

export enum StafferRightsKey {
  ID = 'id',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  LOGIN_NAME = 'loginName',
  EMAIL = 'email',
  EMPLOYED = 'employed',
  HUMAN = 'human',
  INSERT_TIMESTAMP = 'insertTimestamp',
  UPDATED = 'updated',
  VALID = 'valid',
  SEARCH_UNIV = 'searchUniv',
  size = 'size',
  height = 'height',
}

export enum GenresKey {
  ID = 'id',
  MEDIUM_ID = 'mediumId',
  QCODE = 'qcode',
  DISPO_RANK = 'dispoRank',
  VALID = 'valid',
  PRODUCT_MODULE_ID = 'productModuleId',
  PRODUCT_IDS = 'productIds',
  LONG_NAME_DE = 'longNameDE',
  SHORT_NAME_DE = 'shortNameDE',
  LONG_NAME_EN = 'longNameEN',
  SHORT_NAME_EN = 'shortNameEN',
  LONG_NAME_ES = 'longNameES',
  SHORT_NAME_ES = 'shortNameES',
  DISPLAY_ONLY_ON_INTERNAL_PO = 'displayOnlyOnInternalPo',
  MIMIR_MDF = 'mimirMdf',
  MIMIR_FOOTAGETYPE = 'mimirFootagetype',
  MARKED_AS_CHANGED = 'markedAsChanged',
  MARKED_FOR_DELETION = 'markedForDeletion',
}

export enum SearchHeaderEmits {
  UPDATE_SEARCH_PARAMETERS = 'updateSearchParameters',
  DO_SEARCH = 'doSearch',
}
export enum ControlFieldType {
  ControlUndo = 'ControlUndo',
  ControlAddNew = 'ControlAddNew',
  ControlTrash = 'ControlTrash',
  ControlHistory = 'ControlHistory',
  ControlExpand = 'ControlExpand',
  EMPTY = 'EMPTY',
  HISTORY = 'HISTORY',
  DRAG_AND_DROP = 'DRAG_AND_DROP',
}
export enum GeneralFieldTypes {
  TableCellNoEdit = 'TableCellNoEdit',
  TableCellNoEditNew = 'TableCellNoEditNew',
  TableCellEditableNew = 'TableCellEditableNew',
  TableToggleNew = 'TableToggleNew',
  DropDownSingleReka = 'DropDownSingleReka',
  DropDownMultiReka = 'DropDownMultiReka',
  TableCheckbox = 'TableCheckbox',
  InputWithTags = 'InputWithTags',
  Control = 'Control',
}

export enum RevertStatus {
  REVERT_OK = 'REVERT_OK',
  REVERT_FAILED = 'REVERT_FAILED',
  SKIP = 'SKIP',
}

export enum GeneralEmits {
  VALIDATE_CHANGE = 'validateChange',
  SET_CHANGED_STATUS = 'setChangedStatus',
  EMPTY_FIELD = 'emptyField',
  REFRESH_ID = 'refreshId',
  OPEN_HISTORY = 'openHistory',
  UPDATE_MODELVALUE = 'update:modelValue',
  BLUR = 'blur-sm',
  SELECT = 'select',
  ADD_NEW = 'addNew',
  EXIT_EDIT_MODE = 'exitEditMode',
  MARK_FOR_DELETION = 'markForDeletion',
  CLICK = 'click',
  EXPAND = 'expand',
}

export enum DeletedPosSearchParam {
  SEARCH_STRING = 'searchString',
  TO_DATE = 'toDate',
  FROM_DATE = 'fromDate',
  NO_DATE = 'noDate',
  DELETE_DATE = 'deleteDate',
}

export enum ControlKey {
  FIRST_COL = 'firstCol',
  SECOND_COL = 'secondCol',
}

export enum DeletedPosKey {
  ID = 'id',
  TYPE_ID = 'typeId',
  PERIOD = 'period',
  TITLE = 'title',
  DETAIL = 'detail',
  CATEGORY_ID = 'categoryId',
  DELETE_STAFFER_ID = 'deleteStafferId',
  DELETE_TIMESTAMP = 'deleteTimestamp',
}

export enum GeopolKey {
  ID = 'id',
  KIND = 'kind',
  GEO_SUBJECT = 'geoSubject',
  UPPER_GEOPOL = 'upperGeopol',
  QCODE = 'qcode',
  VALID = 'valid',
  ISO_3166_ALPHA_3_CODE = 'iso3166Alpha3Code',
  LONG_NAME_DE = 'longNameDE',
  LONG_NAME_EN = 'longNameEN',
  LONG_NAME_ES = 'longNameES',
  MARKED_FOR_DELETION = 'markedForDeletion',
  MARKED_AS_CHANGED = 'markedAsChanged',
  HIDE = 'hide',
}

export enum KeywordKey {
  ID = 'id',
  VALID = 'valid',
  QCODE = 'qcode',
  SPORTS_RANK = 'sportsRank',
  LONG_NAME_DE = 'longNameDE',
  LONG_NAME_EN = 'longNameEN',
  LONG_NAME_ES = 'longNameES',
  MARKED_FOR_DELETION = 'markedForDeletion',
  MARKED_AS_CHANGED = 'markedAsChanged',
  HIDE = 'hide',
}

export enum KeywordTables {
  SUBJECTS = 'SUBJECTS',
  KEYWORDS = 'KEYWORDS',
  GEO = 'GEO',
}

export enum SubjectKey {
  ID = 'id',
  VALID = 'valid',
  QCODE = 'qcode',
  SPORTS_RANK = 'sportsRank',
  LONG_NAME_DE = 'longNameDE',
  LONG_NAME_EN = 'longNameEN',
  LONG_NAME_ES = 'longNameES',
  MARKED_FOR_DELETION = 'markedForDeletion',
  MARKED_AS_CHANGED = 'markedAsChanged',
  HIDE = 'hide',
}

export enum StafferDispotypeKey {
  ID = 'id',
  ABSENT = 'absent',
  FREELANCE = 'freelance',
  FUNCTION = 'function',
  RANK = 'rank',
  RANK_REPORT = 'rankReport',
  SHORT_NAME_DE = 'shortNameDE',
  LONG_NAME_DE = 'longNameDE',
  SHORT_NAME_EN = 'shortNameEN',
  LONG_NAME_EN = 'longNameEN',
  MARKED_FOR_DELETION = 'markedForDeletion',
  MARKED_AS_CHANGED = 'markedAsChanged',
  HIDE = 'hide',
}

export enum SectionKey {
  ID = 'id',
  VALID = 'valid',
  SHORT_NAME_DE = 'shortNameDE',
  LONG_NAME_DE = 'longNameDE',
  SHORT_NAME_EN = 'shortNameEN',
  LONG_NAME_EN = 'longNameEN',
  CATEGORY_IDS = 'categoryIds',
  MARKED_FOR_DELETION = 'markedForDeletion',
  MARKED_AS_CHANGED = 'markedAsChanged',
  HIDE = 'hide',
}

export enum ProductContainerKey {
  ID = 'id',
  SHORT_NAME = 'shortName',
  LONG_NAME = 'longName',
  PRODUCT_IDS = 'productIds',
  MARKED_FOR_DELETION = 'markedForDeletion',
}

export enum ProductKey {
  ID = 'id',
  QCODE = 'qcode',
  SHORT_NAME = 'shortName',
  LONG_NAME = 'longName',
  LONG_NAME_EXTERNAL_DIFFERENT = 'longNameExternalDifferent',
  RANK = 'rank',
  LANGUAGE = 'language',
  MEDIUM_IDS = 'mediumIds',
  USING_MEDIA_DISPOSITIONS = 'usingMediaDispositions',
  MIMIR_PRODUCT = 'mimirProduct',
  VALID = 'valid',
  DSV_AUDIENCE_QCODES = 'dsvAudienceQCodes',
  MARKED_AS_CHANGED = 'MARKED_AS_CHANGED',
  HIDE = 'HIDE',
}

export enum ReleaseNotesEmits {
  CHANGE = 'change',
  CLICK = 'click',
  ENTER_EDIT_MODE = 'enterEditMode',
  ADD_ENTRY_TO_UNSAVED_LIST = 'addEntryToUnsavedList',
  REMOVE_ENTRY_FROM_UNSAVED_LIST = 'removeEntryFromUnsavedList',
}

export enum ReleaseNoteKey {
  EDIT_MODE = 'editMode',
  DRAFT_ENTRY = 'draftEntry',
  IS_OPEN = 'isOpen',
  ENTRY = 'entry',
  DRAFT_RELEASE_DATE_TIME = 'draftReleaseDateTime',
}

export enum ReleaseNoteTypes {
  TOP = 'top',
  BODY = 'body',
  BOTTOM = 'bottom',
}

export enum RubricKey {
  ID = 'id',
  VALID = 'valid',
  LONG_NAME_DE = 'longNameDE',
  LONG_NAME_EN = 'longNameEN',
  LONG_NAME_ES = 'longNameES',
  HIDE = 'hide',
  MARKED_AS_CHANGED = 'markedAsChanged',
}

export enum TeamContainerKey {
  ID = 'id',
  SHORT_NAME = 'shortName',
  LONG_NAME = 'longName',
  TEAM_IDS = 'teamIds',
  MARKED_FOR_DELETION = 'markedForDeletion',
}

export enum TeamKey {
  ID = 'id',
  SHORT_NAME = 'shortName',
  LONG_NAME = 'longName',
  MAJOR_RANK = 'majorRank',
  MINOR_RANK = 'minorRank',
  DEFAULT_CATEGORY_ID = 'defaultCategoryId',
  DEFAULT_GENRE_ID = 'defaultGenreId',
  PRODUCT_IDS = 'productIds',
  PHONE = 'phone',
  EMAIL = 'email',
  VALID = 'valid',
  MEDIA_OBJECT_PRODUCER = 'mediaObjectProducer',
  EDITORIAL = 'editorial',
  MARKED_AS_CHANGED = 'markedAsChanged',
  HIDE = 'hide',
}

export enum TopicContainerKey {
  ID = 'id',
  SHORT_NAME = 'shortName',
  LONG_NAME = 'longName',
  LANGUAGE = 'language',
  CATEGORIES = 'categories',
  MARKED_AS_CHANGED = 'markedAsChanged',
  MARKED_FOR_DELETION = 'markedForDeletion',
}

export enum TopicKey {
  ID = 'id',
  QCODE = 'qcode',
  RANK = 'rank',
  SHORT_NAME_DE = 'shortNameDE',
  LONG_NAME_DE = 'longNameDE',
  SHORT_NAME_EN = 'shortNameEN',
  LONG_NAME_EN = 'longNameEN',
  SHORT_NAME_ES = 'shortNameES',
  LONG_NAME_ES = 'longNameES',
  MARKED_AS_CHANGED = 'markedAsChanged',
}

export enum PopperSide {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}

export enum SortBy {
  NONE = 'NONE',
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum TableEmits {
  SORT = 'sort',
}

export enum Roles {
  Produce = 'produce',
  Stafferdispo = 'stafferdispo',
  Assign = 'assign',
  Release = 'release',
  Publish = 'publish',
  Admin = 'admin',
  Videoadmin = 'videoadmin',
  Organisation = 'organisation',
}

export enum Languages {
  German = 'de',
  English = 'en',
  Spanish = 'es',
}
